module.exports = "/_next/static/images/yazawa_top-3084e5e40d5836cedf299314c167396c.jpg";